var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPulsando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.04 55.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes pulse {\n      0%, 100% { transform: scale(1); opacity: 1; }\n      50% { transform: scale(1.3); opacity: 0.6; }\n    }\n    .pulse {\n      animation: pulse 1.5s infinite ease-in-out;\n    }\n    .delay-1 { animation-delay: 0s; }\n    .delay-2 { animation-delay: 0.2s; }\n    .delay-3 { animation-delay: 0.4s; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a7d5d5",
    stroke: "#fff",
    x: 18.16,
    y: 0.5,
    width: 237.38,
    height: 43.88
  }), /*#__PURE__*/React.createElement("text", {
    fontSize: "38px",
    fill: "#fff",
    fontFamily: "Mukta Mahee, sans-serif",
    stroke: "#fff",
    x: 101.47,
    y: 34.35
  }, "\n        GE", /*#__PURE__*/React.createElement("tspan", {
    x: 143.99
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 163.61
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.89
  }, "ORE")), /*#__PURE__*/React.createElement("circle", {
    className: "pulse delay-1",
    fill: "#56b2b4",
    cx: 8.01,
    cy: 21.1,
    r: 8.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "pulse delay-2",
    fill: "#56b2b4",
    cx: 34.51,
    cy: 21.1,
    r: 8.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "pulse delay-3",
    fill: "#56b2b4",
    cx: 59.02,
    cy: 21.1,
    r: 8.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPulsando);
export default __webpack_public_path__ + "static/media/logo-pulsando.3515fa49e9fa07253b2339310d54330a.svg";
export { ForwardRef as ReactComponent };